
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Trophy, Award, Star } from 'lucide-react';

const BeamScoreInfo: React.FC = () => {
  return (
    <Card className="bg-white border border-gray-200 shadow-sm mb-6">
      <CardContent className="pt-6">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Understanding the BEAM Score</h3>
        
        <p className="text-gray-700 mb-4">
          The BEAM Score is a core weighted Emotion Resonance metric that measures the overall emotional and strategic value 
          of your project on a scale of 0-100. It combines emotional connection, brand equity, market adaptability, and 
          stakeholder trust indicators to provide a comprehensive assessment.
        </p>
        
        <div className="mb-6">
          <h4 className="text-md font-semibold text-gray-700 mb-2">BEAM Certification Levels</h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="p-3 border border-gray-100 rounded-lg bg-yellow-50">
              <div className="flex items-center gap-2 mb-1">
                <Trophy className="h-5 w-5 text-yellow-600" />
                <span className="font-semibold text-gray-800">BEAM Gold</span>
              </div>
              <div className="text-sm text-gray-600">90-100 points</div>
              <div className="text-xs text-gray-500 mt-1">Exceptional emotional resonance and strategic value</div>
            </div>
            
            <div className="p-3 border border-gray-100 rounded-lg bg-gray-50">
              <div className="flex items-center gap-2 mb-1">
                <Award className="h-5 w-5 text-gray-500" />
                <span className="font-semibold text-gray-800">BEAM Silver</span>
              </div>
              <div className="text-sm text-gray-600">80-89 points</div>
              <div className="text-xs text-gray-500 mt-1">Strong emotional connection with growth potential</div>
            </div>
            
            <div className="p-3 border border-gray-100 rounded-lg bg-amber-50">
              <div className="flex items-center gap-2 mb-1">
                <Star className="h-5 w-5 text-amber-600" />
                <span className="font-semibold text-gray-800">BEAM Bronze</span>
              </div>
              <div className="text-sm text-gray-600">70-79 points</div>
              <div className="text-xs text-gray-500 mt-1">Solid foundation with areas for improvement</div>
            </div>
          </div>
        </div>
        
        <div className="space-y-3">
          <p className="text-sm text-gray-700">
            <span className="font-medium">Emotion Resonance</span>: The BEAM Score is primarily a core weighted Emotion Resonance metric, 
            measuring how deeply your project connects with its audience on an emotional level.
          </p>
          
          <p className="text-sm text-gray-700">
            <span className="font-medium">Holistic Assessment</span>: It incorporates multiple dimensions including emotional connection, 
            ethical alignment, adaptation potential, and stakeholder engagement.
          </p>
          
          <p className="text-sm text-gray-700">
            <span className="font-medium">Actionable Insights</span>: A higher BEAM Score correlates with stronger brand loyalty, 
            increased advocacy, and sustainable market position.
          </p>
        </div>
      </CardContent>
    </Card>
  );
};

export default BeamScoreInfo;
